module.exports = __webpack_public_path__ + "static/media/claw-marks.5c5e0d71.svg";